import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
    .hero-image-area {
        height             : 700px;
        position           : relative;
        overflow           : hidden;

        .hero-slider-wrapper {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;

            .swiper-container {
                width: 100%;
                height: 100%;

                .swiper-btn {
                    position   : absolute;
                    top        : 50%;
                    left       : 40px;
                    width      : 45px;
                    height     : 45px;
                    font-size  : 24px;
                    color      : #ffffff;
                    background : rgba(255, 255, 255, 0.15);
                    text-align : center;
                    padding-top: 5px;
                    border-radius : 5px;
                    transition : all 0.3s ease;
                    margin-top: -35px;
                    z-index   : 111;
                    cursor    : pointer;
                    pointer-events: auto;

                    &:hover {
                        background: ${colors.gr_bg};
                        color     : #ffffff;
                    }
                }

                .swiper-btn.slider-button-next {
                    left : inherit;
                    right: 40px;
                }
            }

            .slider-item {
                width: 100%;
                height: 100%;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                position: relative;

                &::before {
                    position  : absolute;
                    content   : "";
                    background: ${colors.black1};
                    opacity   : 0.6;
                    width     : 100%;
                    height    : 100%;
                    top       : 0;
                    left      : 0;
                    z-index   : 2;
                    pointer-events: none;
                }
            }
        }

        .hero-table {
            display : table;
            width   : 100%;
            height  : 100%;
            position: absolute;
            top     : 0;
            left    : 0;
            z-index : 3;
            pointer-events: none;

            .hero-tablecell {
                display       : table-cell;
                vertical-align: middle;

                .hero-box {
                    pointer-events: auto;

                    h1 {
                        font-size    : 46px;
                        color        : #ffffff;
                        max-width    : 700px;
                        margin       : auto;
                        margin-bottom: 20px;
                        font-weight  : 600;

                        @media(max-width: 767px) {
                            font-size: 26px;
                            font-weight: 500;
                            max-width: 100%;
                        }
                    }

                    p {
                        font-size    : 16px;
                        color        : ${colors.border3};
                        max-width    : 600px;
                        line-height  : 30px;
                        margin       : auto;
                        margin-bottom: 0px;

                        @media(max-width: 575px) {
                            font-size : 15px;
                            line-height : 25px;
                        }
                    }
                }
            }
        }

        @media(max-width: 767px) {
            height : 450px;
        }

        @media(max-width: 575px) {
            height : 360px;
        }
    }
`;